export default __webpack_public_path__ + "static/media/galaxy-cream-header-nobackground.68ee9b98.png";